module.exports = __webpack_public_path__ + "media/images/home/fausto-c52dde0564b1a6fbf277beaf055e5d4c.png";